import type { Dispatch, SetStateAction } from "react";
import { useEffect, useState } from "react";

type Stringifiable = object | string | boolean | number | null;

function getInitialValue<T>(localStorageKey: string, defaultValue: T): T {
  const localStorageItem = localStorage.getItem(localStorageKey);
  if (localStorageItem == null) {
    return defaultValue;
  } else {
    try {
      return JSON.parse(localStorageItem) as T;
    } catch {
      return defaultValue;
    }
  }
}

export function usePersistentValue<T extends Stringifiable>(
  localStorageKey: string,
  defaultValue: T
): [value: T, setValue: Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(getInitialValue(localStorageKey, defaultValue));

  useEffect(() => {
    localStorage.setItem(localStorageKey, JSON.stringify(value));
  }, [localStorageKey, value]);

  return [value, setValue];
}
